/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU128Decoder,
  getU128Encoder,
} from "@solana/kit";

export interface PositionRewardInfo {
  growthInsideCheckpoint: bigint;
  amountOwed: bigint;
}

export interface PositionRewardInfoArgs {
  growthInsideCheckpoint: number | bigint;
  amountOwed: number | bigint;
}

export function getPositionRewardInfoEncoder(): FixedSizeEncoder<PositionRewardInfoArgs> {
  return getStructEncoder([
    ["growthInsideCheckpoint", getU128Encoder()],
    ["amountOwed", getU64Encoder()],
  ]);
}

export function getPositionRewardInfoDecoder(): FixedSizeDecoder<PositionRewardInfo> {
  return getStructDecoder([
    ["growthInsideCheckpoint", getU128Decoder()],
    ["amountOwed", getU64Decoder()],
  ]);
}

export function getPositionRewardInfoCodec(): FixedSizeCodec<
  PositionRewardInfoArgs,
  PositionRewardInfo
> {
  return combineCodec(
    getPositionRewardInfoEncoder(),
    getPositionRewardInfoDecoder(),
  );
}
